import React from "react"
import PropTypes from "prop-types"
import { Field } from "redux-form"
import ReactSelect from "react-select"

const Select = ({input, options}) => (
  <ReactSelect {...input}
    clearable={false}
    searchable={false}
    options={options}
    onBlur={() => input.onBlur(input.value)}
    onChange={(option) => input.onChange(option.value)}
  />
)

Select.propTypes = {
  input: PropTypes.object,
  options: PropTypes.array
}

const IntervalField = ({item, currentValues, label}) => {
  if (!currentValues) return null
  const weekOptionText = currentValues.dayOfWeek || "Week"
  const options = [
    {label: weekOptionText, value: "Week"},
    {label: "Day", value: "Day"},
    {label: "Month", value: "Month"}
  ]
  return (
    <div className="edit-recurrings__interval-field">
      {label && <label>{label}</label>}
      <Field
        name={`${item}interval`}
        component={Select}
        options={options}
      />
    </div>
  )
}

IntervalField.propTypes = {
  currentValues: PropTypes.object,
  item: PropTypes.string,
  label: PropTypes.string
}

export default IntervalField
